import React, { useState } from 'react';
import PropTypes from 'prop-types';

import EditModal from './EditModal';
import Section from './Section';

const DetailsEditor = ({ organization, onOrganizationChange, socials, onSave }) => {
  const [activeField, setActiveField] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = ({target: {name, value}}) => {
    const newOrganization = {
      ...organization,
      [name]: value
    };

    onOrganizationChange(newOrganization);
  };
  
  const handleImageRemove = () => {    
    const newOrganization = {
      ...organization,
      [activeField + '_file']: null,
      [activeField + '_url']: null,
    };

    onOrganizationChange(newOrganization);
  };

  const handleEdit = (field) => () => {   
    setActiveField(field);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Section 
        organization={organization}
        onOrganizationChange={onOrganizationChange}
        onEdit={handleEdit}
      />

      <EditModal
        open={dialogOpen}
        value={activeField === "cover_image" || activeField === "logo" ? organization[`${activeField}_url`] : organization[activeField]}
        name={activeField}
        file={organization[`${activeField}_file`]}
        customCtaAction={activeField === 'custom_cta' ? organization.custom_cta_action : null}
        socials={socials}
        onSave={onSave}
        onChange={handleChange}
        onCancel={handleClose}
        onClose={handleClose}
        onImageRemove={handleImageRemove}
      />
    </>
  );
};

DetailsEditor.propTypes = {
  organization: PropTypes.object,
  onOrganizationChange: PropTypes.func,
  socials: PropTypes.array,
  onSave: PropTypes.func,
};

export default DetailsEditor;